export default "__VITE_ASSET__Chx0F_9W__"